import { toast } from '@/components/toast';
import { GetAgentItemsResponse, getMyAgentsWithKnowledges } from '@/services/api';
import { logger } from '@/services/logger';
import { useState } from 'react';
import { useQuery } from 'react-query';

export const GET_AGENTS_KEY = 'GET_AGENTS_KEY';

const queryInterval = 3000;

export function useGetAgents(isAnonymous: boolean | undefined) {
    const [refetchInterval, setRefetchInterval] = useState<number | false>(false);

    return useQuery<GetAgentItemsResponse>(GET_AGENTS_KEY, () => getMyAgentsWithKnowledges(!!isAnonymous), {
        refetchOnWindowFocus: false,
        onSuccess: ({ shouldPoll }) => {
            setRefetchInterval(!!shouldPoll && queryInterval);
        },
        refetchInterval,
        onError: err => {
            logger.error('Could not fetch agent library', { err });
            toast.error({ title: 'Could not fetch agent gallery', toastId: `${GET_AGENTS_KEY}-error` });
        },
    });
}
